<template>
  <div class="all">
    <div style="margin-top: 20px" class="header">用户使用协议</div>
    <div class="container">
      <p>本平台由武田中国设立并自行或委托第三方运营。本平台仅用于武田中国与医疗卫生专业人士间的交流，如您不属于医疗卫生专业人士，或者不同意本协议，烦请退出注册。 </p>
      <p>武田中国：直接或委托第三方提供本平台和相关服务的法律实体，包括武田（中国）投资有限公司、武田（中国）国际贸易有限公司、武田药品（中国）有限公司及天津武田药品有限公司的一家或多家。</p>

      <p class="title">1.	适用范围</p>
      <p>本协议中所有条款适用于您对本平台（微信公众号名称：吾医空间，账号：gh_2d053a85aa0c）注册及使用。</p>

      <p class="title">2.	用户范围</p>
      <p>本平台仅针对医疗卫生专业人士使用。</p>
      <p>如果您是医疗卫生专业人士，</p>
      <p class="indent1">（1）您应确保您每次使用本平台时，您均为医疗卫生专业人士；如您在注册后，不再持有医疗卫生专业人士资格，请及时注销本平台账户；</p>
      <p class="indent1">（2）您向武田中国提供的关于医疗卫生专业人士的相关资料均真实、准确、完整； </p>
      <p class="indent1">（3）您理解并同意，就您医疗卫生专业人士的资格，武田中国将自行或委托第三方进行验证； </p>
      <p class="indent1">（4）您进一步理解并同意，您是作为医学卫生领域独立的专业人士接受武田中国于本平台提供的所有信息，并将对该等信息做出独立的专业判断；您的处方、推荐、采购和/或其他专业行为和/或决定将不会因武田中国向您提供上述学术信息而受到任何不正当的影响。</p>
      <p class="indent1" style="text-indent:0px;">本内容仅针对医疗卫生专业人士，旨在向且仅向医疗卫生专业人士提供科学信息，用于个人学习和参考之用。如果您不是医疗卫生专业人士，请勿注册、参与或传播。</p>

      <p class="title">3.	内容</p>
      <p class="indent1">本平台的内容仅为学术交流之用途。您理解并同意，武田中国会做积极的努力提供最新的信息，但对本平台信息的准确性、时效性和完整性不做任何形式的保证，也不承担任何责任。本平台的内容不应用于取代医生或其他医学卫生专业人员的看诊、通话、咨询或建议。 </p>

      <p class="title">4.	转发</p>
      <p>您理解并知悉，本平台的内容仅针对医学卫生专业人士阅读。如您需对内容进行转发或其他形式的分享，请确保转发的接受者亦为医学卫生专业人士，且应确保受众并非不特定的大众。</p>

      <p class="title">5.	回复</p>
      <p>作为本平台的用户，如果您就本平台的内容回复信息（包括诸如问题、意见、建议等反馈或资料），这些信息将不被视为保密信息。对于上述信息，武田中国不承担任何义务，并且可以自由地复制和使用该信息，或者将其披露和分发给他人。武田中国可以自由地将该信息中所包含的任何想法、理念、诀窍或者技术用于任何目的，包括但不限于开发、生产和销售包含该信息的产品。</p>

      <p class="title">6.	第三方内容</p>
      <p>本平台包含第三方内容，本平台也提供其他互联网站点的链接。对第三方提供的信息或我们提供链接的其他网站的内容，武田中国不承担任何责任。这些互联网网站受其各自网站上所列明的适用于其自身的使用条款。</p>

      <p class="title">7.	后果</p>
      <p>如果您违反本协议的条款，武田中国有权暂停或者注销您的账户。如果您的违约行为给他人造成损害，您同意就任何及所有的损失、损害或费用向武田中国赔偿。</p>

      <p class="title">8.	隐私</p>
      <p>就使用本平台所涉及的相关隐私问题，详见本平台《隐私指引》。</p>

      <p class="title">9.	法律适用</p>
      <p class="">本协议适用中华人民共和国法律。您理解并同意，您使用本平台应符合中华人民共和国法律法规、部门规章、规范性文件、行业惯例及公序良俗，不应侵害他人的合法权利。 </p>

      <p class="title">10.	条款的接受</p>
      <p class="">一旦您注册本平台，即说明您已同意本协议的约束并遵守本协议。</p>

      <p class="title">11.	注销</p>
      <p class="">如您需要注销本平台账户，请点击本平台“注销账户”。您取消关注“吾医空间”微信公众号不表示您注销“吾医空间”账号。您注销本平台账户后，您将不能获得针对医疗卫生专业人士的相关信息。
</p>

    </div>
    <div v-if="!outSource" style="text-align: center;margin:10px 0 50px;padding-bottom: 50px;">
      <button @click="$router.history.go(-1)" class="redButton">返回</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      outSource: this.$route.query.outSource
    }
  },
  created () {
  },
  mounted () {
    if (process.env.config.seviceUrl.indexOf('wechatweb.takeda.com.cn') > -1) {
      document.title = '吾医空间'
    } else {
      document.title = '吾医空间测试号'
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  #login{
    justify-content: center;
    align-items: center;
    height: 100vh;
    overflow: auto;
    background-color: #fff;
  }
  .all{
    width: 90%;
    margin-left: 5%;
  }
  .header{
    font-size: 20px;
    text-align: center;
    margin-bottom: 8px;
    font-weight: bold;
  }
  .container{
    text-align: justify;
    font-size: 14px;
  }
  .container .indent1{
    text-indent:6px;
  }
  p.title{
    text-indent:0em;
    font-size: 16px;
    font-weight: bold;
    color: #001866;
  }
  p.indent{
    text-indent:24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/userAgreement.vue